/**
 * Decode base64-encoded little-endian numeric buffers from the fire-array
 * endpoints into typed arrays for client-side animation.
 *
 * The backend sends rasters (arrival times, at-ignition metrics, burn
 * probability) as base64 of the raw buffer — ~2x smaller than JSON number lists
 * and decodes directly into a typed-array view. float32 `+inf` (unburned cells)
 * round-trips as `Infinity`.
 */

function b64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64);
  const len = bin.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
  return bytes;
}

/** Decode base64 → Float32Array (little-endian f32). */
export function b64ToF32(b64: string): Float32Array {
  const bytes = b64ToBytes(b64);
  // Copy into an aligned buffer (the decoded bytes' offset is 0, but slice to be safe).
  return new Float32Array(bytes.buffer.slice(0, bytes.byteLength));
}

/** Decode base64 → Uint8Array. */
export function b64ToU8(b64: string): Uint8Array {
  return b64ToBytes(b64);
}
